var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"topbar"},[_c('div',{staticClass:"noise-chart"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("소음 그래프")])],1),_vm._v(" "),_c('div',{staticClass:"noise-chart"},[_c('router-link',{attrs:{"to":"/average"}},[_vm._v("등가 소음")])],1)]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dbf1c12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 